import React from 'react';
import { motion } from 'framer-motion';

const ButtonBase = ({
  children,
  action = () => {},
  animateTap = true,
  className = '',
  style = {},
  disabled = false,
}) => {
  return (
    <motion.button
      whileTap={{ scale: animateTap ? 0.9 : 1 }}
      transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      className={`button ${className}`}
      onClick={action}
      style={style}
      disabled={disabled}
    >
      {children}
    </motion.button>
  );
};

export default ButtonBase;
